// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/styles/iconfont.css'
import 'vue-easytable/libs/themes-base/index.css'
import VueParticles from 'vue-particles'
import axios from 'axios'
import { VTable, VPagination } from 'vue-easytable'
import VCharts from 'v-charts'
import store from './store'
import Toasted from 'vue-toasted'
import Confirm from 'vue-confirm'
import qs from 'qs'
Vue.use(VueParticles)
Vue.use(VCharts)
// vue-toasted
Vue.use(Toasted, {
  position: 'top-right',
  // theme: 'bubble',
  duration: 3000,
  containerClass: 'itoast',
  className: 'iconfont',
  action: {
    text: '关闭',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    }
  }
})
Vue.toasted.register('apperror', '操作失败...', {
  type: 'error',
  icon: 'error_outline'
})
Vue.use(Confirm)

// vue - easytable
Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
/* eslint-disable no-new */
Vue.prototype.axios = axios
axios.defaults.baseURL = 'https://iserver.szxinzhizao.com'
// axios.defaults.baseURL = 'http://localhost:9009'
// axios.defaults.baseURL = 'https://iservice.fansjay.cn'
// axios.defaults.timeout = 55000
// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization')
      // 修改 Content-Type
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    // if (config.method === 'post') { // post请求时，处理数据
    //   config.data = qs.stringify({
    //     ...config.data // 后台数据接收这块需要以表单形式提交数据，而axios中post默认的提交是json数据,所以这里选用qs模块来处理数据，也有其他处理方式，但个人觉得这个方式最简单好用
    //   })
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  })

// 响应拦截器
axios.interceptors.response.use(
  res => { return res },
  error => {
    if (error.response.status === 401) {
      // refreshtoken是否存在
      if (localStorage.getItem('RefreshToken')) {
        // console.log('发现未授权时 RefreshToken====>', localStorage.getItem('RefreshToken'))
        axios.post('/connect/token', qs.stringify({
          grant_type: 'refresh_token', refresh_token: localStorage.getItem('RefreshToken'), client_id: 'IServiceVue', client_secret: '24d6ddf9fc324a258d143dbd5b482ab8'
        }))
          .then((response) => {
            // console.log('通过刷新Token登录返回===>', response)
            if (response.status === 200) {
              localStorage.setItem('Authorization', response.data.token_type + ' ' + response.data.access_token)
              localStorage.setItem('RefreshToken', response.data.refresh_token)
              router.push('/cms')
            }
          }).catch(errors => {
            router.replace('/login')
          })
      } else {
        router.replace('/login')
      }
    }
    return Promise.reject(error)
  })

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// 全局获取缓存数据
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'navititle') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent')
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal)
  }
}



// WEBPACK FOOTER //
// ./src/main.js